import { LOYALTY_STATUS } from '../models/loyalty-status-type.enum';
import { MarketplaceState } from '../models/marketplace-state.model';
import { REWARD_STATUS } from '../models/reward-status.enum';

/**
 * Maps a v2 `REWARD_STATUS` to the LOYALTY_STATUS-based `MarketplaceState` the mixed-loyalty
 * consumers expect, mirroring the theme naming `LoyaltyStatusService` uses for v1 items. Shared by
 * every v2 source, since v2 marketplace items and v2 lottos both carry `REWARD_STATUS`.
 */
export function mapRewardStatusToLoyaltyStatus(rewardStatus: REWARD_STATUS): MarketplaceState {
  switch (rewardStatus) {
    case REWARD_STATUS.ComingSoon:
      return new MarketplaceState({ theme: 'coming-soon', status: LOYALTY_STATUS.COMING_SOON });
    case REWARD_STATUS.SoldOut:
      return new MarketplaceState({ theme: 'sold-out', status: LOYALTY_STATUS.SOLD_OUT });
    case REWARD_STATUS.NotEnoughPoints:
      return new MarketplaceState({ theme: 'not-enough-points', status: LOYALTY_STATUS.NOT_ENOUGH_POINTS });
    case REWARD_STATUS.LimitReached:
      return new MarketplaceState({ theme: 'limit-reached', status: LOYALTY_STATUS.LIMIT_REACHED });
    case REWARD_STATUS.LimitedItem:
      return new MarketplaceState({ theme: 'limited-item', status: LOYALTY_STATUS.LIMITED_STOCK });
    case REWARD_STATUS.LimitedStock:
      return new MarketplaceState({ theme: 'stock-low', status: LOYALTY_STATUS.STOCK_LOW });
    case REWARD_STATUS.NewItem:
      return new MarketplaceState({ status: LOYALTY_STATUS.NEW });
    case REWARD_STATUS.Favourite:
      return new MarketplaceState({ status: LOYALTY_STATUS.FEATURED });
    case REWARD_STATUS.DisabledManualEntry:
      return new MarketplaceState({ theme: 'item-locked', status: LOYALTY_STATUS.LOCKED });
    case REWARD_STATUS.ViewableOnly:
    case REWARD_STATUS.None:
    default:
      return new MarketplaceState({ status: LOYALTY_STATUS.NONE });
  }
}
